// @plasser/ui — shared viewport hook for the surfaces (single source so the
// LayeredModalHost and useFlowSurface copies cannot drift apart).

import * as React from "react";

/** True when the viewport is at most `breakpoint - 1` px wide (SSR-safe). */
export function useIsMobile(breakpoint = 640): boolean {
  const query = `(max-width: ${breakpoint - 1}px)`;
  const get = () =>
    typeof window !== "undefined" && window.matchMedia ? window.matchMedia(query).matches : false;
  const [isMobile, setIsMobile] = React.useState(get);
  React.useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mql = window.matchMedia(query);
    const handler = () => setIsMobile(mql.matches);
    handler();
    mql.addEventListener("change", handler);
    return () => mql.removeEventListener("change", handler);
  }, [query]);
  return isMobile;
}
